"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrescriptionByScriptNumber = exports.usePrescriptionsInfinite = exports.usePrescriptions = void 0;
var prescription_1 = require("../prescription");
var react_query_1 = require("react-query");
function usePrescriptions(prescriptionParams, options) {
    return (0, react_query_1.useQuery)(["prescription", prescriptionParams], function () { return (0, prescription_1.getPrescriptions)(prescriptionParams); }, options);
}
exports.usePrescriptions = usePrescriptions;
function usePrescriptionsInfinite(prescriptionParams) {
    return (0, react_query_1.useInfiniteQuery)(["prescriptionInfinite", prescriptionParams], function (context) {
        return (0, prescription_1.getPrescriptions)(__assign(__assign({}, prescriptionParams), { pageNumber: context.pageParam || 0 }));
    }, {
        getNextPageParam: function (lastPage, allPages) {
            if (allPages
                .map(function (p) { return p.prescriptions.length; })
                .reduce(function (total, curLength) { return total + curLength; }) >=
                lastPage.totalPrescriptions)
                return undefined;
            return allPages.length;
        },
        getPreviousPageParam: function () { return undefined; },
    });
}
exports.usePrescriptionsInfinite = usePrescriptionsInfinite;
function usePrescriptionByScriptNumber(scriptNumber, options) {
    return (0, react_query_1.useQuery)(["prescription", scriptNumber], function () { return (0, prescription_1.getPrescriptionByScriptNumber)(scriptNumber); }, options);
}
exports.usePrescriptionByScriptNumber = usePrescriptionByScriptNumber;
